const NEXEN_BUCKET_PORTAL_URL = process.env.REACT_APP_NEXEN_BUCKET_PORTAL;

export default NEXEN_BUCKET_PORTAL_URL;
